/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SessionControllerFindMySessions200ResponseDataInner { 
    id?: string;
    platform?: string;
    deviceId?: string;
    deviceName?: string;
    userAgent?: string;
    /**
     * IP de origen. Completa solo con el permiso ViewClientIp; si no, recortada (189.203.x.x)
     */
    ip?: string;
    approxLocation?: string;
    createdOn?: string;
    lastActivityAt?: string;
    expiresAt?: string;
    isCurrent?: boolean;
}

